// extracted by mini-css-extract-plugin
module.exports = {"error":"UploadError_error__2LIrB"};